import React from "react";
import { SistemaComponenteInterno } from "~/pages/Sistema/componentes";
import { SLTableCell } from "~/pages/Sistema/componentes/SistemaList";
import { ThisTable } from "./styles";

function TableComponent() {
  return (
    <>
      <SistemaComponenteInterno>
        <ThisTable>
          <SLTableCell className="col-w-2" name="codigoDevice" inputfilter>
            Device
          </SLTableCell>
          <SLTableCell name="titulo" inputfilter>
            Titulo
          </SLTableCell>
          <SLTableCell className="col-w-3" name="unidade.nome" inputfilter>
            Unidade
          </SLTableCell>
          <SLTableCell className="col-w-3" name="centroCusto.titulo" inputfilter>
            Centro de Custo
          </SLTableCell>
        </ThisTable>
      </SistemaComponenteInterno>
    </>
  );
}

export default TableComponent;
